import React from 'react';
import useRouterTransition from '@h/useRouterTransition';

export function withRouterTransition(WrappedComponent) {
  return function CheckoutStateWrapper(props) {
    const routerTransitioning = useRouterTransition();
    return <WrappedComponent {...props} routerTransitioning={routerTransitioning} />;
  };
}
